<div class="main-content table-page table-page--compact table-page--dense monitoreo-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Monitoreo de asistencia</h1>
        <p>Quién llegó, quién no y dónde.</p>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                [disabled]="loading" (click)="exportarCsv()">
          <span class="material-icons">download</span>
          Exportar
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--narrow">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Desde</mat-label>
              <input matInput aria-label="Desde" [matDatepicker]="desdePicker" [(ngModel)]="filtroDesde" />
              <mat-datepicker-toggle matIconSuffix [for]="desdePicker"></mat-datepicker-toggle>
              <mat-datepicker #desdePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--narrow">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Hasta</mat-label>
              <input matInput aria-label="Hasta" [matDatepicker]="hastaPicker" [(ngModel)]="filtroHasta" />
              <mat-datepicker-toggle matIconSuffix [for]="hastaPicker"></mat-datepicker-toggle>
              <mat-datepicker #hastaPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Cliente</mat-label>
              <mat-select [(ngModel)]="filtroCliente" (ngModelChange)="cambioCliente()">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let cliente of clientes" [value]="cliente.id">
                  {{ cliente.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Sitio</mat-label>
              <mat-select [(ngModel)]="filtroUbicacion">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let sitio of ubicacionesVisibles" [value]="sitio.id">
                  {{ sitio.nombre }}<span *ngIf="sitio.nombreCliente"> · {{ sitio.nombreCliente }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Estatus</mat-label>
              <mat-select [(ngModel)]="filtroEstatus">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let estatus of estatusVisibles" [value]="estatus">
                  {{ etiquetaEstatus(estatus) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Modalidad</mat-label>
              <mat-select [(ngModel)]="filtroModalidad">
                <mat-option [value]="null">Todas</mat-option>
                <mat-option value="OFICINA">Oficina</mat-option>
                <mat-option value="HOME_OFFICE">Home office</mat-option>
                <mat-option value="MIXTO">Mixto</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  (click)="limpiarFiltros()">
            <span class="material-icons">filter_alt_off</span>
            Limpiar
          </button>
          <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="consultaPagina(1)">
            <span class="material-icons">search</span>
            Consultar
          </button>
        </div>
      </div>

      <div class="monitoreo-page__resumen" *ngIf="hayResumen">
        <div class="monitoreo-page__resumen-item" *ngFor="let estatus of estatusVisibles">
          <span class="monitoreo-page__resumen-valor">{{ totalDe(estatus) }}</span>
          <span class="monitoreo-page__resumen-etiqueta">{{ etiquetaEstatus(estatus) }}</span>
        </div>
      </div>

      <div class="table-page__table-wrap" *ngIf="renglones.length > 0; else monitoreoEmptyState">
        <table class="table-page__table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Colaborador</th>
              <th>Sitio</th>
              <th>Modalidad</th>
              <th>Esperada</th>
              <th>Entrada</th>
              <th>Salida</th>
              <th>Estatus</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let renglon of renglones">
              <td><span class="table-page__text">{{ soloFecha(renglon.fecha) }}</span></td>
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ renglon.nombreEmpleado }}</strong>
                  <span class="table-page__subtext">{{ renglon.usuario || "-" }}</span>
                </div>
              </td>
              <td>
                <div class="table-page__cell-stack">
                  <span class="table-page__text">{{ etiquetaSitio(renglon) }}</span>
                  <span class="table-page__subtext monitoreo-page__aviso" *ngIf="renglon.ubicacionDistinta">
                    Registró en otro sitio
                  </span>
                </div>
              </td>
              <td><span class="table-page__text">{{ etiquetaModalidad(renglon) }}</span></td>
              <td><span class="table-page__text">{{ soloHora(renglon.horaEsperadaEntrada) || "-" }}</span></td>
              <td>
                <div class="table-page__cell-stack">
                  <span class="table-page__text">{{ soloHora(renglon.horaEntradaReal) || "-" }}</span>
                  <span class="table-page__subtext" *ngIf="renglon.minutosRetardo > 0">
                    +{{ renglon.minutosRetardo }} min
                  </span>
                  <span class="table-page__subtext monitoreo-page__origen"
                        *ngIf="renglon.horaEntradaReal && renglon.origenEntrada">
                    <span class="material-icons" aria-hidden="true">{{ iconoOrigen(renglon.origenEntrada) }}</span>
                    {{ etiquetaOrigen(renglon.origenEntrada) }}
                  </span>
                </div>
              </td>
              <td><span class="table-page__text">{{ soloHora(renglon.horaSalidaReal) || "-" }}</span></td>
              <td><span [class]="claseEstatus(renglon.estatus)">{{ etiquetaEstatus(renglon.estatus) }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #monitoreoEmptyState>
        <div class="table-page__empty" *ngIf="!loading; else monitoreoLoadingState">
          <span class="material-icons">event_busy</span>
          <h3>No hay registros en el periodo</h3>
          <p>Ajuste las fechas o el sitio. Si el día apenas empieza, todavía no hay nada que evaluar.</p>
        </div>
      </ng-template>

      <ng-template #monitoreoLoadingState>
        <div class="table-page__empty table-page__empty--loading">
          <span class="material-icons">hourglass_top</span>
          <h3>Consultando asistencia</h3>
          <p>Espere un momento mientras se reúnen los registros del periodo.</p>
        </div>
      </ng-template>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ (currentPage - 1) * pageSize + 1 }} a {{ rangeEnd }} de {{ totalRegistros }}</span>
        </div>
        <nav class="table-page__pager" aria-label="Paginación">
          <button type="button" class="table-page__pager-link" title="Primera página" aria-label="Primera página"
                  [disabled]="currentPage === 1" (click)="firstPage()">
            <span class="material-icons">first_page</span>
          </button>
          <button type="button" class="table-page__pager-link" title="Página anterior" aria-label="Página anterior"
                  [disabled]="currentPage === 1" (click)="previousPage()">
            <span class="material-icons">chevron_left</span>
          </button>
          <ng-container *ngFor="let item of getPaginationItems()">
            <button type="button" class="table-page__pager-page"
                    [class.is-current]="item === currentPage"
                    *ngIf="isPageNumber(item); else puntosSuspensivos"
                    (click)="onPageChange(+item)">
              {{ item }}
            </button>
            <ng-template #puntosSuspensivos><span class="table-page__pager-ellipsis">…</span></ng-template>
          </ng-container>
          <button type="button" class="table-page__pager-link" title="Página siguiente" aria-label="Página siguiente"
                  [disabled]="currentPage === totalPages" (click)="nextPage()">
            <span class="material-icons">chevron_right</span>
          </button>
          <button type="button" class="table-page__pager-link" title="Última página" aria-label="Última página"
                  [disabled]="currentPage === totalPages" (click)="lastPage()">
            <span class="material-icons">last_page</span>
          </button>
        </nav>
        <div class="table-page__page-size">
          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Por página</mat-label>
            <mat-select [(ngModel)]="pageSize" (selectionChange)="onPageSizeChange(pageSize)">
              <mat-option *ngFor="let tamano of pageSizeOptions" [value]="tamano">{{ tamano }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </section>
  </div>
</div>
